import { APP_DOMAINS, APP_ROUTES_PERMISSIONS } from '~/types';
import { Route } from '../constants';
import { OwnerResponse } from '~/components/contexts/SessionProvider';

export const genRoutes = (
  routes: Partial<Record<APP_DOMAINS, Route>>,
  t: (key: string) => string,
  owner: OwnerResponse,
  agentId: string | undefined,
): Record<APP_DOMAINS, Route> => {
  // Remove routes based on agent role
  const agent = owner.agents.find((agent) => agent._id === agentId);

  const agentDomains = {
    label: t('agents'),
    icon: '',
    routes: owner.agents.map((agent) => ({
      label: agent.name,
      route: agent._id,
    })),
  };

  agentDomains.routes.unshift({
    label: t('create_agent'),
    route: 'create_agent',
  });

  if (!agent) {
    return {
      [APP_DOMAINS.AGENTS]: agentDomains,
    } as Record<APP_DOMAINS, Route>;
  }

  const accessibleDomains = Object.entries(APP_ROUTES_PERMISSIONS)
    .filter(([domain, permission]) => permission.roles.includes(agent.role))
    .reduce(
      (acc, [domain]) => {
        acc[domain as APP_DOMAINS] = routes[domain as APP_DOMAINS] || {
          label: '',
          icon: '',
          routes: [],
        };
        return acc;
      },
      {} as Record<APP_DOMAINS, Route>,
    );

  // Remove empty routes
  Object.entries(accessibleDomains).forEach(([key, value]) => {
    if (!value.label) {
      delete accessibleDomains[key as APP_DOMAINS];
    }
  });

  // Don't add agent routes to the navigation menu
  // The agent switching functionality should be handled elsewhere
  // accessibleDomains[APP_DOMAINS.AGENTS] = agentDomains;

  return accessibleDomains;
};

export const genLink = ({
  domain,
  agentIdParams,
  subRoute,
}: {
  domain: APP_DOMAINS;
  agentIdParams: string;
  subRoute?: string;
}): string => {
  if (subRoute === 'create_agent') {
    return '/create_agent';
  }

  if (domain === APP_DOMAINS.AGENTS) {
    return `/agent/${subRoute}/dashboard`;
  }

  return `/agent/${agentIdParams}/${subRoute}`;
};
